import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Container } from 'ui/container'
import { Banner } from 'features/tasks/banner'
import { List } from 'features/tasks/list'
import { PageTitle } from '../../features/common/page-title'
import { useAuthContext } from '../../core/providers/AuthProvider'

import c from './assets/sass/page.module.scss'

const TasksPage = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { updateUserData } = useAuthContext()
    const handleFAQ = () => {
        navigate('/faq?category=tasks')
    }

    return (
        <div className={c.component}>
            <PageTitle title={t('pages.tasks.title')} callback={handleFAQ} />
            <Container>
                <Banner />
                <List onTaskComplete={updateUserData} />
            </Container>
        </div>
    )
}

export default TasksPage
